export function isValidUrl(string) {
  try {
    new URL(string);
  } catch (_) {
    return false;
  }
  return true;
}

export function returnValidUrl(string) {
  return isValidUrl(string) ? string : `http://${string}`;
}

export function getSvgStoreUrl(img) {
  var images = require.context('../assets/images/icones/', false, /\.svg$/)
  return images('./logo-' + img + '.svg')
}

export function getSvgIntegrationIcon(img) {
  var images = require.context('../assets/images/icones/', false, /\.svg$/)
  return images('./icon-' + img + '.svg')
}